import * as d3 from "d3";
import "./css/style.less";
import cfg from "./config.json";
import salaires from "./data/salaires.json";
import top20 from "./data/top20.json";

var data = { config:cfg, salaires:salaires, top20:top20 };

function init() {
  const sel = d3.select("#viz");

  const pnum = function(str) {
    if (str == "nd") return str;
    return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1&nbsp;');
  }

  const makelist = function(str) {
    var listItems  = str.split('; ');
    var finalHTML = ``;
    listItems.map((item) => {
      finalHTML += `<li>${item}</li>`;
    });
    return finalHTML;
  }

  init();

  function init() {

    const regionsData = Array.from(d3
        .group(data.salaires, d => d.region_adm))
        .sort(d3.ascending)
        .map(d => {
          return {
            region_name: d[0]
          }
        });

    const filterRegionOrTitre = () => {
      var functionSelectValue = d3.select('#fonctionElu').property('value');
      functionSelectValue = functionSelectValue === "Tous les élus" ? "default" : functionSelectValue;
      // functionSelectValue = functionSelectValue === "Maire/Mairesse suppléant/e" ? "Maire suppléant/Mairesse suppléante" : functionSelectValue;
      functionSelectValue = functionSelectValue === "Maire/Mairesse d'arrondissement" ? "Maire d'arrondissement/Mairesse d'arrondissement" : functionSelectValue;
      functionSelectValue = functionSelectValue === "Conseiller/Conseillère" ? "Conseiller/Conseillère/Conseiller d'arrondissement/Conseillère d'arrondissement" : functionSelectValue;
      var selectedTitresArray = functionSelectValue.split('/');

      var selectedRegionValue = d3.select('#regions select').property('value');
      let filteredElus;

      if (functionSelectValue === 'default' && selectedRegionValue === 'default') {
        filteredElus = data.salaires;
        // console.log("filtering NOTHANG");
      } else {
        if (selectedRegionValue === 'default') {
          // CASE : toutes les regions, titre différent : filtre uniquement sur le titre
          // console.log("filtering titre only");
          filteredElus = data.salaires.filter(function (d) {
                if(selectedTitresArray.indexOf(d.titre_genre2) !== -1) return d
              })

        } else if (functionSelectValue === 'default')  {
          // CASE : tous les types, region différente : filtre uniquement sur la région
          // console.log("filtering region only");
          filteredElus = data.salaires.filter(function (d) {
                if (d.region_adm === selectedRegionValue) return d
              })
        }
        else {
          // CASE : région et type différents : filtre sur les deux
          // console.log("filtering region AND titre");
          filteredElus = data.salaires.filter(function (d) {
                if (selectedTitresArray.indexOf(d.titre_genre2) !== -1 && d.region_adm === selectedRegionValue) return d
              })
        }
      }
      if (filteredElus.length > 0) {
        render_results(filteredElus)
      } else {
        render_no_results()
      }
    }

    const filterKeyword = () => {
      var input, filter, table, i;
      input = document.getElementById("keywordInput");
      filter = input.value.toUpperCase();
      table = document.getElementById("rows");
      var rows = table.getElementsByTagName("tr");
      for (i = 0; i < rows.length; i++) {
        rows[i].classList.remove('expanded');
        if (rows[i].classList.contains('details')) {
          rows[i].remove();
        }
        var cells = rows[i].getElementsByTagName("td");
        var j;
        var rowContainsFilter = false;
        for (j = 0; j < cells.length; j++) {
          if (cells[j]) {
            if (cells[j].innerHTML.toUpperCase().indexOf(filter) > -1) {
              rowContainsFilter = true;
              continue;
            }
          }
        }

        if (!rowContainsFilter) {
          rows[i].style.display = "none";
        } else {
          rows[i].style.display = "";
        }
      }
      let visibleRows = document.querySelectorAll('#rows tr:not([style*="display: none"])').length;
      d3.select(".no-result").classed('hidden', visibleRows !== 0);

    }

    const titresDropdown = d3
        .select("#fonctionElu")
        .on('change', filterRegionOrTitre)

    const keyword = d3
        .select("#keywordInput")
        .on('keyup', filterKeyword)

    const regionsDropdown = d3
        .select("#regions .content .select-wrapper")
        .append('select')
        .attr('class', 'select')
        .attr("name", "region-list")
        .on('change', filterRegionOrTitre)

    const regionsOption = regionsDropdown
        .selectAll('option')
        .data(regionsData)
        .enter()
        .append('option')
        .attr('value',(d) => d.region_name )
        .text( (d) => d.region_name );

    const defaultRegionOption = regionsDropdown
        .append('option')
        .attr('value', 'default')
        .attr('selected', 'selected')
        .text("Toutes les régions")

    function render_no_results() {
      d3
          .select("#results .content")
          .html(`<p class="no-results no-user-select">Aucun résultat</p>`);
    }

    function render_results(salaires) {
      d3
          .select("#results .content")
          .html(`<div class="table-wrap">
      <table cellpadding="0" cellspacing="0" class="sortable">
        <thead class="table-head">
            <tr>
                <th class="pointer nom  ">Nom, <span class="break-on-mobile">Titre</span></th>
                <th class="pointer municipalite ">Municipalité <span class="break-on-mobile">(Population)</span></th>
                <th class="pointer remuneration ">Rémunération</th>
                <th class="details disable-sort">Détails</th>
            </tr>   
        </thead>
        <tbody id="rows" class="table-body">
            
        </tbody>
      </table>
      </div>
     
    `);

      var row = d3
          .select("#results")
          .select("#rows")
          .selectAll(".row")
          .data(salaires, (d, i) => `row-${i}`)
          .enter()
          .call(render_row)

      filterKeyword();
    }

    const render_row = (sel) => {

      const row = sel.append('tr')
          .attr("class","row summary first")
          .classed('added-to-comparator',(d)=>d.compared)
          .attr("id", function(d,i){ return "summary"+i});


      row.append('td').attr('class','nom-et-fonction').attr('data-sort',(d) => d.nom_famille).html((d) => {
        let arondissement = (d.arrondissement !== '' && d.arrondissement !== 'undefined') ? `,<br> ${d.arrondissement}` : ``;
        return d.nom_corrige2+', <span class="fonction">'+d.titre_genre2+arondissement+'</span>';});
      // row.append('td').html((d) => d.titre);
      row.append('td').attr('data-sort',(d) => d.ville).attr('class','ville-et-population').html((d) => d.ville+'  <span class="population">('+pnum(d.population)+')</span>');
      // row.append('td').attr('data-sort',(d) => d.population === "nd" ? "0" : d.population).html((d) => pnum(d.population));
      row.append('td').attr('class','salaire').attr('data-sort',(d) => d.total === "nd" ? "0" : d.total).html((d) => `${pnum(d.total)}&nbsp;$`);
      row.append('td').attr('class','details-toggle details-toggle-full').html(`<span class="material-symbols-rounded">add</span>`);

      d3.selectAll(".details-toggle-full")
          .on("click", toggle_details)

    }

    const toggle_details = (e) => {
      let sel = d3.select(e.target.parentNode)
      let d = sel.datum()
      let selId = "#"+e.target.parentNode.id+" + *";
      let selDetailsId = "#"+e.target.parentNode.id+" + .details.expanded";
      let newflag = !sel.classed("expanded")
      /** if not already expanded, append infos **/
      if (newflag) {
        sel.classed("expanded",newflag)
        d3.select('#rows')
            .insert('tr', selId)
            .attr('class', 'row details second expanded')
            .html(t => {

              return `<td class="content no-user-select" colspan="7">
               <div class="detailed-infos">
                <div class="detailed-infos-top two-cols">
                  <div class="col1">
                    <p class="gras">Rémunération de base</p>
                    <p class="salaire">${pnum(d.remuneration)}&nbsp;$</p>
                  </div>
                  <div class="col2">
                    <p class="gras">Allocation de base</p>
                    <p class="salaire">${pnum(d.allocation)}&nbsp;$</p>
                  </div>
                  <div class="col1">
                    <p class="gras">Rémunération additionnelle</p>
                    <p class="salaire">${pnum(d.remuneration2)}&nbsp;$</p>
                  </div>
                  <div class="col2">
                    <p class="gras">Allocation additionnelle</p>
                    <p class="salaire">${pnum(d.allocation2)}&nbsp;$</p>
                  </div>
                </div>
              </div>
            </td>`
            })
      } else { /** if already expanded, remove class and remove details container **/
      sel.classed("expanded",false)
        d3.select(selDetailsId).remove()
      }
    }

    function render_top20(top20) {
      d3
          .select("#top20 .content")
          .html(`<div class="table-wrap">
      <table cellpadding="0" cellspacing="0" class="disable-sort">
        <thead class="table-head">
            <tr>
                <th class="rang disable-sort">Rang</th>
                <th class="nom  disable-sort">Nom</th>
                <th class="municipalite  disable-sort">Municipalité</th>
                <th class="remuneration  disable-sort">Rémunération</th>
                <th class="details disable-sort">Détails</th>
            </tr>   
        </thead>
        <tbody id="rowstop20" class="table-body">
            
        </tbody>
      </table>
      </div>
     
    `);

      var row = d3
          .select("#top20")
          .select("#rowstop20")
          .selectAll(".row")
          .data(top20, (d, i) => `row-${i}`)
          .enter()
          .call(render_rowTop20)

      d3.selectAll(".details-toggle-top20")
          .on("click", toggle_details_top20)
    }

    const render_rowTop20 = (sel) => {

      const row = sel.append('tr')
          .attr("class","row summary first")
          .classed('added-to-comparator',(d)=>d.compared)
          .attr("id", function(d,i){ return "summary"+i});

      const pnum = function(str) {
        if (str == "nd") return str;
        return str.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1&nbsp;');
      }



      row.append('td').html((d) => { let filename = (d.nom).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(" ","_"); return `<div><span>${d.classement}</span><img class="rounded-profile" src="${data.config.assetsFolder}top20/images/${filename}.jpg" alt="${d.nom}" /></div>`});
      row.append('td').attr('class','nom-elu').html((d) => d.nom);
      row.append('td').attr('class','ville').html((d) => d.ville);
      row.append('td').attr('class','salaire').html((d) => `${pnum(d.total)}&nbsp;$`);
      row.append('td').attr('class','details-toggle details-toggle-top20').html(`<span class="material-symbols-rounded">add</span>`);

    }

    const toggle_details_top20 = (e) => {
      let sel = d3.select(e.target.parentNode)
      let d = sel.datum()
      let selId = "#"+e.target.parentNode.id+" + *";
      let selDetailsId = "#"+e.target.parentNode.id+" + .details.expanded";
      let newflag = !sel.classed("expanded")
      /** if not already expanded, append infos **/
      if (newflag) {
        sel.classed("expanded",newflag)
        d3.select('#rowstop20')
            .insert('tr', selId)
            .attr('class', 'row details second expanded')
            .html(t => {
              let filename = (d.nom).normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(" ","_");

              return `<td class="content no-user-select" colspan="7">
               <div class="detailed-infos">
                <div class="image-left-float">
                   <img src="${data.config.assetsFolder}top20/images/${filename}.jpg" alt="${d.nom}">  
                   <div class="details-infos-wrapper">
                   <p class="gras">Fonctions municipales</p>
                      <div class="detailed-infos-top two-cols">
                        <div class="col1">
                          <ul>
                            ${makelist(d.fonction_base)}
                          </ul>
                        </div>
                        <div class="col2 decompte">
                          <p class="gras">Rémunération de base: <span class="salaire">${pnum(d.remuneration)}&nbsp;$</span></p>
                          <p class="gras">Allocation de base: <span class="salaire">${pnum(d.allocation)}&nbsp;$</span></p>
                        </div>
                      </div>
                      <div class="detailed-infos-bottom two-cols">
                        <div class="col1">
                          <ul>
                            ${makelist(d.fonction_additionnelle)}
                          </ul>
                        </div>
                        <div class="col2 decompte">
                          <p class="gras">Rémunération additionnelle: <span class="salaire">${pnum(d.remuneration2)}&nbsp;$</span></p>
                          <p class="gras">Allocation additionnelle: <span class="salaire">${pnum(d.allocation2)}&nbsp;$</span></p>
                        </div>
                      </div>
                    </div>
                </div>
                
              </div>
            </td>`
            })
      } else { /** if already expanded, remove class and remove details container **/
      sel.classed("expanded",false)
        d3.select(selDetailsId).remove()
      }
    }

    if (data.salaires.length > 0) {
      render_results(data.salaires)
    } else {
      render_no_results()
    }

    if (data.top20.length > 0) {
      render_top20(data.top20)
    }
  }


  document.addEventListener('click', function (e) {
    var down_class = ' dir-d '
    var up_class = ' dir-u '
    var regex_dir = / dir-(u|d) /
    var regex_table = /\bsortable\b/
    var element = e.target

    function reClassify(element, dir) {
      element.className = element.className.replace(regex_dir, '') + dir
    }

    function getValue(element) {
      // If you aren't using data-sort and want to make it just the tiniest bit smaller/faster
      // comment this line and uncomment the next one
      return element.getAttribute('data-sort') || element.innerText
      // return element.innerText
    }

    if (element.nodeName === 'TH' && !element.classList.contains("disable-sort")) {
      try {
        /**Spécifique pour ce tableau**/
            // destroy any open details
        var tablerows = document.getElementById("rows").getElementsByTagName("tr");
        for (i = 0; i < tablerows.length; i++) {
          tablerows[i].classList.remove('expanded');
          if (tablerows[i].classList.contains('details')) {
            tablerows[i].remove();
          }
        }
        /**END - Spécifique pour ce tableau**/

        var tr = element.parentNode
        // var table = element.offsetParent; // Fails with positioned table elements
        // this is the only way to make really, really sure. A few more bytes though... ðŸ˜¡
        var table = tr.parentNode.parentNode
        if (regex_table.test(table.className)) {
          var column_index
          var nodes = tr.cells
          // reset thead cells and get column index
          for (var i = 0; i < nodes.length; i++) {
            if (nodes[i] === element) {
              column_index = i
            } else {
              reClassify(nodes[i], '')
            }
          }

          var dir = down_class

          // check if we're sorting up or down, and update the css accordingly
          if (element.className.indexOf(down_class) !== -1) {
            dir = up_class
          }

          reClassify(element, dir)

          // extract all table rows, so the sorting can start.
          var org_tbody = table.tBodies[0]

          // get the array rows in an array, so we can sort them...
          var rows = [].slice.call(org_tbody.rows, 0)

          var reverse = dir === up_class

          // sort them using custom built in array sort.
          rows.sort(function (a, b) {
            var x = getValue((reverse ? a : b).cells[column_index])
            var y = getValue((reverse ? b : a).cells[column_index])
            // var y = (reverse ? b : a).cells[column_index].innerText
            // var x = (reverse ? a : b).cells[column_index].innerText
            return isNaN(x - y) ? x.localeCompare(y) : x - y
          })

          // Make a clone without content
          var clone_tbody = org_tbody.cloneNode()

          // Build a sorted table body and replace the old one.
          while (rows.length) {
            clone_tbody.appendChild(rows.splice(0, 1)[0])
          }

          // And finally insert the end result
          table.replaceChild(clone_tbody, org_tbody)
        }
      } catch (error) {
        console.log(error)
      }
    }
  })

  var collapsibleTrigger = document.querySelector(".collapse-trigger");
  var content = document.querySelector(".collapsible");
  collapsibleTrigger.addEventListener("click", function() {
    collapsibleTrigger.classList.toggle("active");
    if (content.style.display === "block") {
      content.style.display = "none";
    } else {
      content.style.display = "block";
    }
  });
}

init();

